import { render, staticRenderFns } from "./CollapsiblePanel.global.vue?vue&type=template&id=7121a318&scoped=true&lang=pug&"
import script from "./CollapsiblePanel.global.vue?vue&type=script&lang=ts&"
export * from "./CollapsiblePanel.global.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsiblePanel.global.vue?vue&type=style&index=0&id=7121a318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7121a318",
  null
  
)

export default component.exports